<template>
  <div
    class="slide-section-main office-loaction-inner slider-provider"
    :class="{
      'remove-top': currentRoute === 'AppointmentDetail'
    }"
    style="display: block;"
  >
    <header-vue
      :my-return="myReturn"
      title="Office Location"
      :long-title="true"
    />
    <div class="slide-section-area-wrapper">
      <div class="seprator top"></div>
      <div class="slide-section-inner-wrapper">
        <ul class="check-list">
          <li
            v-for="(location, index) in locations"
            :key="location.id"
            @click="optionSelected(index)"
            :class="{ active: selectedValue === location.address_id }"
          >
            <span>
              <object
                class="svg-back-arrow"
                :data="checkSvg"
                type="image/svg+xml"
              ></object>
            </span>
            <span
              >{{ location.line1 }} {{ location.line2 }} {{ location.city }}
              {{ location.postal_code }}</span
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderVue from "./common/Header.vue";
import { mapGetters, mapMutations } from "vuex";
import { providerDependentMixin } from "../../../../mixins/providerDependentMixin";

export default {
  mixins: [providerDependentMixin],
  props: {
    value: String,
    done: Function
  },
  data() {
    return {
      checkSvg: require("../../../../assets/svg/check-mark.svg")
    };
  },
  computed: {
    ...mapGetters({
      officeLocation: "getOfficeLocation", // Gets the office location details
      getProvider: "getProvider" // Gets the provider details
    }),
    /**
     * Returns a list of the locations of the slected provider
     */
    locations() {
      if (this.selectedProviderId) {
        return this.officeLocation.locationDetails[this.selectedProviderId];
      } else {
        return [];
      }
    },
    /**
     * Returns the selected value of the office location
     */
    selectedValue() {
      return this.locations[this.officeLocation.selectedIndex].address_id;
    },
    /**
     * Gets the current route in the user is at currently
     */
    currentRoute() {
      return this.$router.history.current.name;
    }
  },
  methods: {
    ...mapMutations({
      setOfficeLocation: "setOfficeLocation" // Sets the office location
    }),
    /**
     * Function when an option is selected
     */
    optionSelected(index) {
      this.setOfficeLocation({
        custom: false,
        customValue: "",
        selectedIndex: index
      });
      this.done();
    },
    myReturn() {
      this.done();
    }
  },
  components: {
    HeaderVue
  }
};
</script>

<style scoped>
li {
  cursor: pointer;
}

.slide-section-main {
  overflow: unset;
  top: 108px;
}

.remove-top {
  top: 97px !important;
}
</style>
